<script setup lang="ts">
import { defineAsyncComponent, computed, type Component } from "vue";

interface Props {
    name: string;
    type?: "svg" | "png" | "jpg";
}

const props = withDefaults(defineProps<Props>(), {
    type: "svg",
});

const icon = computed<Component | string>(() => {
    if (props.type === "svg") {
        return defineAsyncComponent(() =>
            import(
                `../../../assets/icons/${props.name}.${props.type}?component`
            ).then((module) => module.default as Component)
        );
    }

    return new URL(
        `../../../assets/icons/${props.name}.${props.type}`,
        import.meta.url
    ).href;
});
</script>

<template>
    <component :is="icon" v-if="type === 'svg'" />
    <img v-else :src="icon as string" :alt="name" />
</template>

<style>
svg {
    overflow: visible;
}
</style>
